import { render, staticRenderFns } from "./CheckoutModal.vue?vue&type=template&id=e64160b0&scoped=true"
import script from "./CheckoutModal.vue?vue&type=script&lang=js"
export * from "./CheckoutModal.vue?vue&type=script&lang=js"
import style0 from "./CheckoutModal.vue?vue&type=style&index=0&id=e64160b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e64160b0",
  null
  
)

export default component.exports